import { useEffect } from 'react';
import { PreferenceItem } from '@sas/nova-core/services/preferences';
import { useSettingsService } from '../GlobalSettingsProvider';

export function useGetSettings(
  resolve: (data: Array<PreferenceItem>) => void,
  reject: () => void
): void {
  const {
    writeAccessState: { isWriteAccessDetected },
    dataProvider,
  } = useSettingsService();

  useEffect(() => {
    let isMounted = true;
    async function _getSettings() {
      try {
        const data = await dataProvider.getSettings();

        if (isMounted) {
          resolve(data.items);
        }
      } catch (error) {
        if (isMounted) {
          reject();
        }
      }
    }
    if (isWriteAccessDetected) {
      _getSettings();
    }
    return () => {
      isMounted = false;
    };
  }, [isWriteAccessDetected, dataProvider, resolve, reject]);
}
